<template>
    <div class="page-container">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <a href="#" class="active">{{ $t("sales") }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="main-card">
            <div class="metrics-wrapper">
                <ul class="box-info">
                    <li>
                        <span class="icon-box">
                            <i class="bi bi-people"></i>
                        </span>
                        <span class="text">
                            <h5>{{ $t("customers") }}</h5>
                            <p>{{ $t("numbers") }} : <strong>{{ costomer }}</strong></p>
                        </span>
                    </li>
                    <li>
                        <span class="icon-box">
                            <i class="bi bi-file-earmark-medical-fill"></i>
                        </span>
                        <span class="text">
                            <h5>{{ $t("invoices") }} {{ $t("sales") }}</h5>
                            <p>{{ $t("numbers") }} : <strong>{{ invoices }}</strong></p>
                        </span>
                    </li>
                </ul>
            </div>

            <div class="body-grid">
                <div class="part">
                    <h6>{{ $t("sales") }}</h6>
                    <ul>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/AdminDashboard/OfferPrice">{{ $t("offer") }} {{ $t("price") }}</router-link>
                        </li>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/AllInvoices">{{ $t("invoice") }} {{ $t("sale") }}</router-link>
                        </li>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/AllReceipts">{{ $t("receipts") }} {{ $t("customers") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part">
                    <h6>{{ $t("products") }} & {{ $t("item") }}</h6>
                    <ul>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/purchases/AllProducts">{{ $t("products") }}</router-link>
                        </li>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/purchases/AllProducts/ProductCategories">{{ $t("item") }}</router-link>
                        </li>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/purchases/AllProducts/UnitTypes">{{ $t("unit type") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part">
                    <h6>{{ $t("customer") }}</h6>
                    <ul>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/Customers">{{ $t("customers") }}</router-link>
                        </li>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/AddProductsToCustomer">{{ $t("add") }} {{ $t("products") }} {{ $t("customers") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part">
                    <h6>{{ $t("POS") }}</h6>
                    <ul>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/CreateShift">{{ $t("create") }} {{ $t("shift") }}</router-link>
                        </li>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/AllPOSReceipt">{{ $t("transactions") }} {{ $t("POS") }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="part">
                    <h6>{{ $t("reports") }} {{ $t("sales") }}</h6>
                    <ul>
                        <li>
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/CustomerStatement">{{ $t("Account Statement") }} {{ $t("customers") }}</router-link>
                        </li>
                        <li v-if="is_subscriped_to_zatca">
                            <i class="bi bi-three-dots-vertical"></i>
                            <router-link to="/sales/zatca-invoices" class="active">{{ $t("الفواتير الضريبية ") }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  props: ["css"],
  data() {
    return {
      costomer: 0,
      suppliers: 0,
      invoices: 0,
      bills: 0,
      salles: "",
      is_subscriped_to_zatca: false
    };
  },
  async mounted() {
    this.is_subscriped_to_zatca = store.state.is_subscriped_to_zatca;
  },
  async created() {
    try {
      const result = await axios.get(`/reports/homesummary`);
      if (result.status === 200) {
        this.costomer = result.data.customer[0]?.count || 0;
        this.suppliers = result.data.suppliers[0]?.count || 0;
        this.invoices = result.data.invoice[0]?.count || 0;
        this.bills = result.data.bills[0]?.count || 0;
        this.salles = result.data.salles;
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
    }
  },
  methods: {
    ...mapActions(["redirectTo"]),
  },
};
</script>

<style lang="scss" scoped>
/* Reset and Container Basics */
.page-container {
    direction: v-bind("css.EN");
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f8f9fa;
    min-height: 100vh;
}

.breadcrumb {
    list-style: none;
    padding: 0;
    margin-bottom: 20px;
    
    li a {
        text-decoration: none;
        font-weight: 600;
        font-size: 1.2rem;
        color: #333;
        
        &.active {
            color: v-bind("css.color");
        }
    }
}

/* Main Dashboard Card Wrapper */
.main-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    padding: 24px;
}

/* Metric Cards Layout */
.box-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    grid-gap: 20px;
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;

    li {
        background: #fdfdfd;
        border: 1px solid #edf2f7;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        align-items: center;
        gap: 20px;
        transition: transform 0.2s, box-shadow 0.2s;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.04);
        }

        .icon-box {
            width: 50px;
            height: 50px;
            border-radius: 10px;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: v-bind("css.color");
            color: #fff; /* Modified for standard modern readability, can adjust dynamically */
        }

        .text {
            h5 {
                font-size: 16px;
                font-weight: 600;
                color: #2d3748;
                margin: 0 0 4px 0;
            }
            p {
                color: #718096;
                font-size: 14px;
                margin: 0;
            }
        }
    }
}

/* Bottom Grid (Navigation Categories) */
.body-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px;
}

.part {
    background-color: #ffffff;
    border: 1px solid #edf2f7;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

    h6 {
        font-size: 16px;
        font-weight: 700;
        color: #1a202c;
        margin-top: 0;
        margin-bottom: 16px;
        border-bottom: 2px solid #edf2f7;
        padding-bottom: 8px;
        text-transform: uppercase;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            font-size: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .bi-three-dots-vertical {
                color: #a0aec0;
                margin-right: 8px;
                font-size: 14px;
            }

            a {
                color: #4a5568;
                text-decoration: none;
                transition: color 0.2s;

                &:hover {
                    color: v-bind("css.color");
                    font-weight: 500;
                }
            }
        }
    }
}

/* Media Queries for Responsiveness */
@media screen and (max-width: 992px) {
    .body-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 576px) {
    .page-container {
        padding: 10px;
    }
    
    .main-card {
        padding: 16px;
    }

    .body-grid {
        grid-template-columns: 1fr;
        grid-gap: 16px;
    }

    .box-info li {
        padding: 16px;
        gap: 12px;
        
        .icon-box {
            width: 40px;
            height: 40px;
            font-size: 20px;
        }
        
        .text h5 {
            font-size: 14px;
        }
        .text p {
            font-size: 12px;
        }
    }
}
</style>